import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import boxReducer from './box';
import layoutReducer from './layout';
import userReducer from './user';
import viewReducer from './view';
import boostReducer from './boost';
import addonsReducer from './addons';

export default combineReducers({
  box: boxReducer,
  layout: layoutReducer,
  routing: routerReducer,
  user: userReducer,
  view: viewReducer,
  boost: boostReducer,
  addons: addonsReducer,
});



// WEBPACK FOOTER //
// ./src/modules/index.js